import styled from "styled-components";
import media from "styled-media-query";

import { Text, ColorV2 } from "@adoptaunabuelo/react-components";

const FooterSection = styled.footer`
	display: flex;
	flex-direction: column;
	width: 100%;
	background:
		linear-gradient(0deg, rgba(0, 29, 61, 0.04), rgba(0, 29, 61, 0.04)),
		var(--surface-background, #f9f6f3);
`;
const Contact = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 64px;
	padding: 64px 16px 0;
	width: 100%;
	box-sizing: border-box;
	${media.lessThan("medium")`
        gap: 32px;
        padding: 48px 24px 0;
    `}
`;
const ContactRow = styled.div`
	display: flex;
	gap: 16px;
	align-items: flex-start;
	width: 100%;
	max-width: 1228px;
	padding: 0 16px;
	box-sizing: border-box;
	${media.lessThan("medium")`
        flex-direction: column;
        gap: 24px;
        padding: 0;
    `}
`;
const Col = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
`;
const Title = styled(Text)`
	font-size: 20px !important;
	line-height: 28px !important;
	font-weight: 600 !important;
	color: ${ColorV2.text.neutralHard};
	margin: 0;
`;
const LinkText = styled.a`
	font-family: "Poppins", sans-serif;
	font-size: 15px;
	line-height: 24px;
	font-weight: 500;
	color: ${ColorV2.text.neutralHard};
	text-decoration: underline;
	margin: 0;
	&:hover {
		color: ${ColorV2.text.primary};
	}
`;
const PhoneDesc = styled(Text)`
	font-size: 13px !important;
	line-height: 18px !important;
	color: ${ColorV2.text.neutralMedium};
	margin: 0;
`;
const Divider = styled.div`
	height: 1px;
	width: 100%;
	max-width: 1228px;
	background-color: ${ColorV2.border.neutralSoft};
`;
const Caption = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	min-height: 72px;
	box-sizing: border-box;
	padding: 0 16px;
	${media.lessThan("medium")`
        min-height: 0;
        padding: 16px 24px 105px;
    `}
`;
const CaptionInner = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	max-width: 1228px;
	padding: 0 16px;
	box-sizing: border-box;
`;
const CaptionRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 4px 6px;
	align-items: center;
`;
const CaptionItem = styled(Text)`
	font-size: 13px !important;
	line-height: 18px !important;
	color: ${ColorV2.text.neutralMedium};
	margin: 0;
	white-space: nowrap;
`;
const Dot = styled(CaptionItem)`
	font-size: 14px !important;
	line-height: 20px !important;
`;
const LegalLink = styled.a`
	font-family: "Poppins", sans-serif;
	font-size: 13px;
	line-height: 18px;
	font-weight: 400;
	color: ${ColorV2.text.neutralMedium};
	text-decoration: none;
	white-space: nowrap;
	padding: 6px 4px;
	border-radius: 6px;
	&:hover {
		color: ${ColorV2.text.neutralHard};
		text-decoration: underline;
	}
`;

const SiteFooter = () => (
	<FooterSection>
		<Contact>
			<ContactRow>
				<Col>
					<Title type="p">Atención al embajador</Title>
				</Col>
				<Col>
					<LinkText
						href="https://wa.me/34661398020"
						target="_blank"
						rel="noopener noreferrer"
					>
						+34 661 39 80 20
					</LinkText>
					<PhoneDesc type="p">
						Escríbenos por WhatsApp o llámanos de lunes a jueves de 9:00 a
						18:30 h y los viernes de 9:00 a 15:00 h
					</PhoneDesc>
				</Col>
				<Col>
					<LinkText href="mailto:socios@adoptaunabuelo.com">
						socios@adoptaunabuelo.com
					</LinkText>
				</Col>
			</ContactRow>
			<Divider />
		</Contact>
		<Caption>
			<CaptionInner>
				<CaptionRow>
					<CaptionItem type="p">
						©{new Date().getFullYear()} Adopta Un Abuelo
					</CaptionItem>
					<Dot type="p">·</Dot>
					<LegalLink
						href="https://www.adoptaunabuelo.org/politica-de-cookies"
						target="_blank"
						rel="noopener noreferrer"
					>
						Política de cookies
					</LegalLink>
					<Dot type="p">·</Dot>
					<LegalLink
						href="https://www.adoptaunabuelo.org/politica-privacidad"
						target="_blank"
						rel="noopener noreferrer"
					>
						Política de privacidad
					</LegalLink>
					<Dot type="p">·</Dot>
					<LegalLink
						href="https://www.adoptaunabuelo.org/terminos-condiciones"
						target="_blank"
						rel="noopener noreferrer"
					>
						Términos y condiciones
					</LegalLink>
				</CaptionRow>
			</CaptionInner>
		</Caption>
	</FooterSection>
);

export default SiteFooter;
